import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../components/layoutBlack";
import PromotionForm from "../components/promoForm";

const Promotion = () => {
        // Parse URL query parameters
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const promo = queryParams.get("promo")?.toUpperCase();

    useEffect(() => {
        window.scrollTo(0, 0);
        }, []);

    return (
        <div>
            <Layout>
            {/* Title Section */}   

                {/* Content Section */}
            <section className="full-page-section bg-light p-t-125 p-b-150">
            <div className="container">
                <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="p-4 border rounded bg-white">
                    <PromotionForm promo_code={promo} />
                    </div>
                </div>
                </div>
            </div>
            </section>
            </Layout>
        </div>
    );
};

export default Promotion;
